import { GET_EXPORT_JOBS_FAILURE, GET_EXPORT_JOBS_REQUEST, GET_EXPORT_JOBS_SUCCESS, GetExportJobsActionTypes, GetExportJobsState } from './types';

const defaultState: GetExportJobsState = {
  isLoading: false,
  errorMessage: '',
};

export default function getExportJobs(state = defaultState, action: GetExportJobsActionTypes): GetExportJobsState {
  switch (action.type) {
    case GET_EXPORT_JOBS_REQUEST:
      return { ...state, isLoading: true };
    case GET_EXPORT_JOBS_SUCCESS:
      return { ...state, contents: action.contents, isLoading: false, errorMessage: '' };
    case GET_EXPORT_JOBS_FAILURE:
      return { ...state, isLoading: false, errorMessage: '' };
    default:
      return state;
  }
}
